import { init as initApm } from '@elastic/apm-rum'

// Initialize the APM agent
const apm = initApm({
  serviceName: 'gatsby-frontend',
  serverUrl: 'https://4eeda01fe7584ba3b107557700d76866.apm.francecentral.azure.elastic-cloud.com:443',
  serviceVersion: '',
  environment: 'my-environment',
  // Add other configuration options as needed
})

export default apm